var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    { attrs: { height: _vm.height ? _vm.height : _vm.h } },
    [
      _c("v-calendar", {
        ref: "calendar",
        class: { cursor: _vm.disabled },
        attrs: {
          id: "calendar",
          color: "primary",
          type: "week",
          "show-week": true,
          events: _vm.events,
          "event-ripple": false,
          "interval-format": _vm.intervalFormatter,
          weekdays: _vm.weekday,
          scrollToTime: "08:00"
        },
        on: {
          "mousedown:event": _vm.startDrag,
          "click:event": _vm.showEvent,
          "mousedown:time": _vm.startTime,
          "mousemove:time": _vm.mouseMove,
          "mouseup:time": _vm.endDrag
        },
        nativeOn: {
          mouseleave: function($event) {
            return _vm.cancelDrag.apply(null, arguments)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "event",
            fn: function(ref) {
              var event = ref.event
              var timed = ref.timed
              return [
                _c("div", { staticClass: "v-event-draggable" }, [
                  _c("strong", [_vm._v(_vm._s(event.name))]),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formatEventTime(event.start)) +
                      " - " +
                      _vm._s(_vm.formatEventTime(event.end)) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                timed && !_vm.disabledView
                  ? _c("div", {
                      class: { "v-event-drag-bottom": !_vm.disabled },
                      on: {
                        mousedown: function($event) {
                          $event.stopPropagation()
                          return _vm.extendBottom(event)
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            activator: _vm.selectedElement,
            "offset-x": ""
          },
          model: {
            value: _vm.selectedOpen,
            callback: function($$v) {
              _vm.selectedOpen = $$v
            },
            expression: "selectedOpen"
          }
        },
        [
          _c(
            "v-card",
            {
              attrs: { color: "grey lighten-4", "min-width": "150px", flat: "" }
            },
            [
              _c(
                "v-list",
                { staticStyle: { "text-align": "start" } },
                [
                  _c(
                    "v-list-item",
                    { on: { click: _vm.removeTask } },
                    [
                      _c(
                        "v-btn",
                        { attrs: { icon: "" } },
                        [_c("v-icon", [_vm._v("event_busy")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [_vm._v("Remove from calendar")]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e3a2bed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e3a2bed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderCalendar.vue
// module id = null
// module chunks = 